/** Fixed storage allocated while loading a scene, never during a frame (GDD §15.7, #70). */
export class ObjectPool<T extends object> {
  private readonly objects: T[];
  private readonly available: T[];
  private readonly acquired = new Set<T>();

  constructor(readonly capacity: number, create: () => T) {
    if (!Number.isInteger(capacity) || capacity < 0) throw new Error('Invalid pool capacity');
    this.objects = Array.from({ length: capacity }, create);
    if (new Set(this.objects).size !== capacity) throw new Error('Pool factory must create distinct objects');
    this.available = [...this.objects];
  }

  acquire(): T {
    const object = this.available.pop();
    if (!object) throw new Error('Object pool exhausted');
    this.acquired.add(object);
    return object;
  }

  release(object: T): void {
    if (!this.acquired.delete(object)) throw new Error('Object was not acquired from this pool');
    this.available.push(object);
  }

  forEach(visit: (object: T) => void): void {
    this.objects.forEach(visit);
  }
}
